// functions/nonOptional.ts
import "../validator.js";
import { ValidationError } from "../errors/ValidationError.js";
var nonOptional = ({ translationKey = "validation_non_optional", allowFalsy } = {}) => (options) => {
  if (options.value === void 0 || options.value === null || !allowFalsy && !options.value) {
    throw new ValidationError(`Key ${options.key} is required!`, { key: options.key, translationKey });
  }
};
export {
  nonOptional
};
